import HomeTwoToneIcon from "@mui/icons-material/HomeTwoTone";
import GroupsTwoToneIcon from "@mui/icons-material/GroupsTwoTone";
import EventTwoToneIcon from "@mui/icons-material/EventTwoTone";
import SettingsTwoToneIcon from "@mui/icons-material/SettingsTwoTone";

function getMenuItens() {
  if (!localStorage.getItem("accessToken")) return [{ heading: "", items: [] }];

  const telaPrincipalItem = {
    name: "Assistente",
    icon: HomeTwoToneIcon,
    link: "/minipay/main",
    monitorType: "MinipayAcessoTelaPrincipal",
    end: true,
  };

  const participantesItem = {
    name: "Participantes",
    icon: GroupsTwoToneIcon,
    link: "/minipay/main/participantes",
    monitorType: "MinipayAcessoParticipantes",
  };

  const eventosItem = {
    name: "Eventos",
    icon: EventTwoToneIcon,
    link: "/minipay/main/eventos",
    monitorType: "MinipayAcessoEventos",
  };

  const configuracoesItem = {
    name: "Configurações",
    icon: SettingsTwoToneIcon,
    link: "/minipay/main/configuracoes",
    monitorType: "MinipayAcessoConfiguracoes",
  };

  return [
    {
      heading: "",
      items: [telaPrincipalItem, participantesItem, eventosItem, configuracoesItem],
    },
  ];
}

export default getMenuItens;
